import { inject, Injectable } from '@angular/core';
import { ICalScanCloudConfig } from '@calsale/scanovate';
import { GLOBAL_SETTINGS } from '@partners/settings';
import { ScanCloudConfig } from '../model/scan-cloud.model';
@Injectable({ providedIn: 'root' })
export class CommonScanCloudConfig extends ScanCloudConfig {
  globalSettings = inject(GLOBAL_SETTINGS);
  constructor() {
    super();

    const { apiUrl, docCode, classNames, iframeStyle } = this.config;
    this.apiUrl = apiUrl;
    this.docCode = docCode;
    this.classNames = classNames;
    this.iframeStyle = iframeStyle;
    this.completeCallbackUrl = this.buildCompleteCallbackUrl();
  }
  buildCompleteCallbackUrl(): string {
    return `${window.location.origin}/scan/scan-document?ignoreNavigation=true`;
  }

  /** scan settings influenced by environment  */
  private get environmentScanConfig(): ICalScanCloudConfig {
    const { environment } = this.globalSettings;
    return environment?.scanConfig;
  }
  get config(): ICalScanCloudConfig {
    return {
      ...this.environmentScanConfig,
      completeCallbackUrl: this.buildCompleteCallbackUrl()
    };
  }
}
